<template>
  <div :class="$style.wrapper">
    <TheVisualWebsiteOptimizer />
    <BaseLoading
      v-if="isRedirecting"
      full-screen
    />
    <CnLanding v-else-if="env === 'cn'" />
    <SummerLandingPage v-else />
  </div>
</template>

<script>

import TheVisualWebsiteOptimizer from '@/pages/Home/Components/Molecules/Tracking/TheVisualWebsiteOptimizer'
import CnLanding from '@/pages/Home/Routes/LandingPage/CnLanding'
import SummerLandingPage from '@/pages/Home/Routes/LandingPage/SummerLandingPage'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'LandingPage',
  components: {
    BaseLoading,
    SummerLandingPage,
    CnLanding,
    TheVisualWebsiteOptimizer,
  },
  data() {
    return {
      isRedirecting: false,
    }
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV
    },
  },
  metaInfo() {
    return {
      title: this.$t('page-titles.home-public'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.home-public') },
      ],
    }
  },
  created() {
    if (process.env.VUE_APP_HAS_SEO_PAGES && window.location.pathname.startsWith('/app')) {
      this.isRedirecting = true
      window.location.href = window.location.origin
    }
  },
}
</script>

<style lang="scss" module>
  .wrapper {
    width: 100vw;
    overflow-x: hidden;
  }
</style>
